<div>
  <canvas #incidencesChart></canvas>
</div>
